import { Link } from 'react-router';

export default function ProcedureRelatedProcedures(props: {
	relatedProcedures: {
		id: string
		name: string
		content: string
		slug: string
	}[]
}) {
	const { relatedProcedures } = props
	return (
		<div className="mt-6 rounded-md bg-amber-50 p-8 shadow-lg">
			<div className="prose ">
				<h2 id="tramites-relacionados">Trámites relacionados</h2>
			</div>
			<ul className="mt-4 max-w-prose divide-y divide-gray-200">
				{relatedProcedures?.map(procedure => (
					<li
						key={procedure.id}
						className="group relative py-5 focus-within:ring-2 focus-within:ring-inset"
					>
						<div className="flex justify-between space-x-3">
							<div className="min-w-0 flex-1">
								<Link
									to={'../' + procedure.slug}
									preventScrollReset
									prefetch="intent"
									className="block hover:underline focus:outline-none"
									relative="path"
								>
									<span className="absolute inset-0" aria-hidden="true" />
									<p className="text-md line-clamp-2  font-extrabold text-gray-900">
										{procedure.name}
									</p>
								</Link>
							</div>
							{/* <time
											dateTime={procedure.updatedAt}
											className="flex-shrink-0 whitespace-nowrap text-sm text-gray-500"
										>
											{procedure.formattedDate}
										</time> */}
						</div>
						<div className="mt-1">
							<p
								className="line-clamp-2 text-sm text-gray-400  group-hover:text-gray-900"
								dangerouslySetInnerHTML={{
									__html: procedure.content,
								}}
							></p>
						</div>
					</li>
				))}
			</ul>
		</div>
	)
}
